import { Type } from 'class-transformer';
import { IsDate, IsEnum, IsNumber, IsOptional, IsString } from 'class-validator';
import { UserId } from '../../../../types';
import { PropertyCreationSource, PropertyMarketState } from './property-enums';

export class PropertyMarketStatusDto {
  @IsEnum(PropertyMarketState)
  state: PropertyMarketState = PropertyMarketState.FOR_SALE;

  @IsEnum(PropertyCreationSource)
  source: PropertyCreationSource = PropertyCreationSource.OWNER;

  @IsOptional()
  @Type(() => Date)
  @IsDate()
  forSaleAt?: Date;

  @IsOptional()
  @Type(() => Date)
  @IsDate()
  underMandateAt?: Date;

  @IsOptional()
  @Type(() => Date)
  @IsDate()
  offerAcceptedAt?: Date;

  @IsOptional()
  @Type(() => Date)
  @IsDate()
  contractSignedAt?: Date;

  @IsOptional()
  @Type(() => Date)
  @IsDate()
  soldAt?: Date;

  @IsOptional()
  @Type(() => Date)
  @IsDate()
  withdrawnAt?: Date;

  @IsOptional()
  @IsNumber()
  finalSellingPriceCents?: number;

  @IsOptional()
  @IsString()
  managedByAgent?: UserId;
}
